// extracted by mini-css-extract-plugin
export var cardContainer = "MediumPosts-module--card-container--8c4cc";
export var cdsAssistiveText = "MediumPosts-module--cds--assistive-text--1410f";
export var cdsHideFeedback = "MediumPosts-module--cds--hide-feedback--cf22d";
export var cdsShowFeedback = "MediumPosts-module--cds--show-feedback--ba115";
export var cdsSkeleton = "MediumPosts-module--cds--skeleton--6407c";
export var cdsVisuallyHidden = "MediumPosts-module--cds--visually-hidden--d58f6";
export var image = "MediumPosts-module--image--7eddc";